<script lang="ts">
  import type { FormEventHandler, KeyboardEventHandler } from 'svelte/elements';
  import { tv } from 'tailwind-variants';

  import SmallGhostButton from '../buttons/SmallGhostButton.svelte';

  let {
    title,
    selected = false,
    onDuplicate,
    onClose,
    onclick,
    onChangeTitle,
  }: {
    title: string;
    selected?: boolean;
    onDuplicate?: () => void;
    onClose?: () => void;
    onclick?: () => void;
    onChangeTitle?: (title: string) => void;
  } = $props();

  let tabText = $state(title);

  const styles = tv({
    base: 'group fr-csb max-w-[216px] flex-1 gap-2 rounded-lg px-4 py-2 font-sans text-label-sm font-medium',
    variants: {
      selected: {
        true: 'min-w-[232px] bg-gradient-to-b from-tabs-from/50 to-tabs-to/50 shadow-tab hocus:from-tabs-from/80 hocus:to-tabs-to/80',
        false: 'min-w-[64px] bg-tabs hover:min-w-[216px] hocus:bg-tabs-H',
      },
    },
  });

  const cn = $derived(styles({ selected }));
  let inputRef: HTMLInputElement | null = $state(null);

  const resetTitle = () => {
    const oldText = tabText;
    tabText = oldText + ' ';
    setTimeout(() => {
      tabText = oldText;
    });
  };

  const blurInput = () => {
    if (inputRef) {
      inputRef.blur();
    }
  };

  const handleTitleSubmit: FormEventHandler<HTMLInputElement> = (e) => {
    const text = (e.currentTarget.value ?? '').trim();

    if (text.length > 0) {
      tabText = text;
      onChangeTitle?.(text);
    } else {
      resetTitle();
    }
  };

  const handleSpecialKey: KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      handleTitleSubmit(e);
      blurInput();
    }
    if (e.key === 'Escape') {
      resetTitle();
      setTimeout(() => {
        blurInput();
      }, 10);
    }
  };

  const handleDuplicate = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onDuplicate?.();
  };
</script>

<button class={cn} {onclick}>
  {#if selected}
    <input
      bind:this={inputRef}
      class="w-full bg-transparent"
      type="text"
      value={tabText}
      onblur={handleTitleSubmit}
      onkeypress={handleSpecialKey}
    />
  {:else}
    <div class="max-w-full truncate py-1">{tabText}</div>
  {/if}
  <div class={selected ? 'fr-cc -mr-2' : '-mr-2 hidden group-hover:fr-cc'}>
    <SmallGhostButton icon="ContentCopy" label="Duplizieren" onclick={handleDuplicate} />
    <SmallGhostButton icon="Close" label="Schließen" onclick={onClose} />
  </div>
</button>
